import * as React from "react";
import {
  IconButton,
  Typography,
  Paper,
  CircularProgress,
  List,
  ListItem,
  Tooltip,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { Library } from "../../models/Library";
import { observer } from "mobx-react";
import * as _ from "lodash";
import { RouteComponentProps } from "react-router";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { LibraryService } from "modules/library/LibraryService";
import { LibraryStore } from "modules/library/LibraryStore";
import { withSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import i18n from "i18n";
import { WBSStore } from "modules/WBS/WBSStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import Dropzone from "../layouts/Dropzone";
import { Render3dService } from "modules/render3D/Render3dService";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { LoginStore } from "modules/login/LoginStore";

// icons
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
  CloudUpload as CloudUploadIcon,
  PlayCircleOutline,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityIconOff,
} from "@material-ui/icons";

const styles = (theme) => ({
  container: {
    backgroundColor: "#2a292f",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column" as any,
    minWidth: "250px",
  },
  topBar: {
    backgroundColor: "#3A393E",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    color: "#dedede",
    marginBottom: "6px",
  },
  paper: {
    background: "#3A393E",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    letterSpacing: "1px",
    paddingLeft: "6px",
  },
  topBarWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "10px",
    alignItems: "center",
  },
  texttitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    color: "#dedede",
  },
  text: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "rgba(255,255,255,0.87)",
    marginBottom: "0",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  textDimmed: {
    fontFamily: "Roboto",
    fontSize: "11px",
    marginBottom: "0",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: "rgba(255, 255, 255, 0.3)",
  },
  textWhite: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "red",
    marginBottom: "0",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  tooltip: {
    width: "190px",
  },
  uploadText: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#A8A8A8",
    padding: "5px",
    letterSpacing: "0.5px",
    marginTop: "4px",
    fontWeight: "600" as any,
  },
  icon: {
    color: "#A8A8A8",
    size: "11px",
    padding: "3px",
    alignItems: "middle",
    "&:disabled": {
      color: "red",
    },
  },
  closeUploadIcon: {
    color: "#AC4D4D",
    size: "20px",
    alignItems: "middle",
    cursor: "pointer",
    transition: "all 0.3s",
    "&:hover": {
      color: "#7b3737",
    },
  },
  iconNew: {
    margin: 0,
    width: "30px",
    height: "30px",
    padding: "3px",
    alignItems: "middle",
  },
  controlWrapper: {
    background: "#363637",
    paddingLeft: "0",
    padding: 0,
    height: "40px",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease-in",
    "&:hover": {
      background: "#464646",
    },
  },
  controlWrapperSelected: {
    background: "#697513",
    paddingLeft: "0",
    padding: 0,
    height: "40px",
    display: "flex",
    alignItems: "center",
    transition: "all 0.3s ease-in",
    "&:focus": {
      background: "#697513",
    },
  },
  iconWrap: {
    padding: "0 2px",
    "&:disabled": {
      "& > span > svg": {
        color: "gray",
      },
    },
  },
  iconUploadText: {
    border: "1px solid #1D1D1D",
    background: "#272727",
    padding: "0",
    textTransform: "uppercase" as any,
    borderRadius: "4px",
    transition: "all 0.3s",
    "&:hover": {
      background: "#353539",
    },
  },
  listicon: {
    color: "#dedede",
    size: "8px",
    padding: "0px",
    alignItems: "left",
  },
  warning: {
    backgroundColor: "#ffa000",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
    zIndex: 2,
    position: "absolute" as any,
    right: "12px" as any,
    width: "26px !important",
    height: "26px !important",
  },
  progressBack: {
    margin: 0,
    color: "rgba(221, 221, 221, 0.40)",
    zIndex: "1" as any,
    position: "absolute" as any,
    right: "12px",
    width: "30px !important",
    height: "30px !important",
  },
  progressCancel: {
    margin: 0,
    color: "#ABC200",
    zIndex: 2,
    position: "absolute" as any,
    right: "12px" as any,
    width: "30px !important",
    height: "30px !important",
  },
  table: {
    display: "table",
    height: "calc(100vh - 105px)",
  },
  tableCell: {
    display: "table-cell",
    verticalAlign: "middle",
    padding: "0 25px",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.87)",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "rgba(255,255,255,0.67)",
  },
  list: {
    margin: "0px",
    overflow: "auto",
  },
  listNew: {
    margin: "0px",
    overflow: "auto",
    padding: 0,
    marginTop: "1px",
  },
  ul: {
    padding: 0,
    display: "inline",
  },
  colorSwitchBase: {
    color: "#dedede",
    "&$colorChecked": {
      color: "#ABC200",
      "& + $colorBar": {
        backgroundColor: "#ABC200",
      },
    },
    display: "flex",
    height: "40px",
    alignItems: "center",
  },
  colorChecked: {
    color: "#ABC200",
  },
  controls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "10px",
    paddingLeft: "10px",
    width: "100%",
    overflow: "hidden",
    "&:hover": {
      "& > :last-child": {
        opacity: 1,
      },
    },
  },
  controlUpload: {
    display: "flex",
    justifyContent: "space-between",
    margin: 0,
    paddingRight: "17px",
    alignItems: "center",
  },
  square: {
    width: "10px",
    height: "10px",
    backgroundColor: "rgba(221, 221, 221, 0.40)",
    zIndex: 3 as any,
    position: "absolute" as any,
    right: "22px",
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#ABC200",
    },
  },
  processing: {
    color: "#FFFFFF !important",
    opacity: "0.7" as any,
    fontStyle: "italic",
    fontSize: "10px",
    marginLeft: "5px",
  },
  processingTitle: {
    color: "#FFFFFF !important",
    opacity: "0.7" as any,
    fontStyle: "italic",
    fontSize: "10px",
  },
  titleDefault: {
    display: "flex",
    flexDirection: "column" as any,
  },
  errorButton: {
    color: "#BC0000",
    transition: "all 0.3s ease-in",
    "&:hover": {
      color: "#800000",
    },
  },
  closeIcon: {
    right: "20px",
    top: "14px",
  },
  divVisibility: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    opacity: 0,
    transition: "all 0.3s ease-in",
    color: "rgba(255, 255, 255, 0.37)",
  },
  divVisibilityOn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    opacity: 1,
    transition: "all 0.3s ease-in",
    color: "#ffffff",
  },
});

const LabelProcessing = ({ className, progress, statusXkt, status }) => {
  return (
    <Typography className={className}>
      {progress && statusXkt != "error" && status != "error"
        ? `Processando ${progress}%`
        : "Aguardando para processamento"}
    </Typography>
  );
};

type IProps = {
  match: RouteComponentProps<any>;
  classes: any;
  libraries: FirebaseDocument<Library>;
  snack: any;
};

@observer
class LibraryGrid extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  state = {
    ready: false,
    deleteValue: "",
    checkedEnabled: [""],
    checkedRender: [""],
    deleteOpen: false,
    anchorElMessage: null,
    messageLib: "",
    activatingIndex: -1,
    selectedIndex: -1,
    open: false,
    snack: false,
    openModal: false,
  };

  componentDidMount() {
    LibraryStore.fetchLibraries(() => {
      const arrayRender = LibraryStore.libraries3DEnabled;
      this.setState({
        checkedRender: arrayRender,
        ready: true,
      });
    });
  }

  componentWillUnmount() {
    LibraryStore.librarySelected = undefined;
  }

  handleListItemClick = (event, index, lib) => {
    this.setState({ selectedIndex: index });
    LibraryStore.librarySelected = lib;
  };

  deleteLibrary = async (event, props) => {
    const fileUploading = LibraryStore.libraryUploading.findIndex(
      (lib) => lib.savedName === LibraryStore.librarySelected!.data.realFileName
    );
    LibraryStore.libraryUploading.splice(fileUploading, 1);

    if (LibraryStore.librarySelected) {
      this.setState({ openModal: false });
      await LibraryService.DeleteLibrary(LibraryStore.librarySelected);
      WBSStore.verifyLibs();
      LibraryStore.progressStatusUpload = 0;
      TakeOffStore.takeOffFormatedList = [];
    } else {
      LibraryStore.snackMessage = i18n.library.message.IFCNotSelected;
      LibraryStore.snack = true;
    }
  };

  addfileHandler = async (event, props) => {
    const files = event.target.files;
    LibraryStore.uploadLibraryFiles(files);
  };

  onHandleDropzone = (acceptedFiles: any) => {
    LibraryStore.uploadLibraryFiles(acceptedFiles);
  };

  async changeRenderFile(lib, checked) {
    await LibraryService.toggleRenderLibrary(lib);
  }

  async addRenderChecked(comp) {
    let array = this.state.checkedRender;
    array.push(comp);
    this.setState({ checkedRender: array });
  }

  deleteRenderChecked(ind) {
    let array = this.state.checkedRender;
    array.splice(ind, 1);
    this.setState({ checkedRender: array });
  }

  cancelUpload(index) {
    LibraryStore.libraryUploading[index].uploadTask.cancel();
    LibraryStore.libraryUploading[index].loading = 0;
  }

  resetProccess = (lib: any) => () => {
    if (
      (lib.data.status !== "processed" && lib.data.status !== "processing") ||
      (lib.data.statusXKt !== "processed" &&
        lib.data.statusXkt !== "processing")
    )
      LibraryService.restartProcesses(lib);
  };

  handleClickClose = () => {
    this.setState({ openModal: false });
  };

  handleClickOpen = () => {
    this.setState({ openModal: true });
  };

  handleVisibilityChange = (name, lib, index) => async (event) => {
    const checked = this.state.checkedRender.findIndex(function (value) {
      return value == name;
    });
    if (checked < 0) {
      this.addRenderChecked(name);
    } else {
      this.deleteRenderChecked(checked);
    }
    await this.changeRenderFile(lib, checked);
    await LibraryStore.changeLibrariesVisibility();
  };

  checkVisibilityChange = () => {
    const list = [...this.state.checkedRender];
    const libraries = LibraryStore.libraries;

    for (const lib of libraries) {
      const { enabled } = lib.data;
      const name = "sw_" + lib.id;

      const index = list.findIndex((item) => item === name);
      const hasChecked = index !== -1;

      if (hasChecked !== enabled) {
        if (enabled) {
          list.push(name);
        } else {
          list.splice(index, 1);
        }
      }
    }

    LibraryStore.setChangeVisibilty(false);
    this.setState({ checkedRender: list });
  };

  handleSnackClose = () => {
    LibraryStore.snack = false;
  };

  handleSnackTimeClose = () => {
    setTimeout(() => (LibraryStore.snack = false), 4000);
  };

  render() {
    const { classes } = this.props;
    const libraries = LibraryStore.libraries;
    const { ready, checkedRender } = this.state;
    const isTrial = LoginStore.isTrialUser();

    const change = LibraryStore.changeVisibilty;
    if (change) {
      this.checkVisibilityChange();
    }

    return (
      <div
        className={classes.container}
        style={{ height: `calc(100vh - ${isTrial ? 68 : 33}px)` }}
      >
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={LibraryStore.snack}
          autoHideDuration={3000}
          onClose={this.handleSnackTimeClose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{LibraryStore.snackMessage}</span>}
          action={[
            <IconButton color="inherit" onClick={this.handleSnackClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <Dialog
          open={this.state.openModal}
          onClose={this.handleClickClose}
          aria-labelledby="draggable-dialog-title"
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
        >
          <DialogTitle id="draggable-dialog-title" style={{ padding: "20px" }}>
            <p style={{ color: "#f2f2f2", fontSize: "18px", margin: 0 }}>
              {i18n.library.delete.title}
            </p>
            <IconButton
              onClick={this.handleClickClose}
              className={classes.closeIcon}
              style={{ position: "absolute" }}
            >
              <Close fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <DialogContentText style={{ padding: 0 }}>
              <p style={{ color: "#a6a6a6", fontSize: "16px", margin: 0 }}>
                {i18n.library.delete.content}
              </p>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              autoFocus
              className={classes.confirmButton}
              onClick={async (event) => {
                await this.deleteLibrary(event, this.props);
              }}
            >
              <Typography style={{ color: "#ABC200" }}>{i18n.yes}</Typography>
            </Button>
            <Button onClick={this.handleClickClose} color="secondary">
              {i18n.no}
            </Button>
          </DialogActions>
        </Dialog>

        <Paper elevation={2} square className={classes.paper}>
          <div className={classes.topBar}>
            <Typography className={classes.topBarText} component="span">
              {i18n.library.title}
            </Typography>
          </div>
          <div className={classes.topBar}>
            <div className={classes.topBarWrapper}>
              {libraries.length > 0 ? (
                <IconButton
                  className={classes.iconWrap}
                  aria-label="Delete"
                  disabled={
                    !LibraryStore.librarySelected ||
                    (LibraryStore.librarySelected.data.status !== "error" &&
                      LibraryStore.librarySelected.data.status !==
                        "processed") ||
                    (LibraryStore.librarySelected.data.statusXkt !== "error" &&
                      LibraryStore.librarySelected.data.statusXkt !==
                        "processed")
                  }
                  onClick={this.handleClickOpen}
                >
                  <DeleteIcon className={classes.icon} />
                </IconButton>
              ) : (
                <div />
              )}
              <input
                id="button-file-upload"
                type="file"
                multiple
                // accept=".ifc, .ifczip"
                accept=".ifc"
                onChange={async (event) => {
                  await this.addfileHandler(event, this.props);
                }}
                onClick={(event: any) => {
                  event.target.value = null;
                }}
                style={{ display: "none" }}
              />

              <label
                className={classes.iconUploadText}
                onClick={() => {
                  const dev = DevelopmentStore.developmentSelected;
                  if (!dev.data.isXeokitViewer) {
                    LibraryStore.snackMessage =
                      i18n.library.message.errorNotXeokitProject;
                    LibraryStore.snack = true;
                  } else {
                    if (document) {
                      var x = document.getElementById("button-file-upload");
                      if (x) {
                        x.click();
                      }
                    }
                  }
                }}
              >
                <IconButton className={classes.iconWrap} component="span">
                  <CloudUploadIcon className={classes.icon} />
                  <Typography className={classes.uploadText}>
                    {i18n.library.upload}
                  </Typography>
                </IconButton>
              </label>
            </div>
          </div>
        </Paper>
        {ready ? (
          <div className={classes.list}>
            {libraries.length > 0 || LibraryStore.progressStatusUpload > 0 ? (
              <List className={classes.listNew}>
                {LibraryStore.libraryUploading !== undefined &&
                LibraryStore.cancel === false ? (
                  LibraryStore.progressStatusUpload < 100 &&
                  LibraryStore.progressStatusUpload > 0 ? (
                    <li className={classes.list}>
                      {LibraryStore.libraryUploading.map(
                        (libraryUploading, index) => {
                          // Só exibe se o id do WBS é o mesmo do arquivo que está sendo atualizado
                          if (
                            libraryUploading.loading == 0 ||
                            libraryUploading.uploadTask.state_ == "canceled" ||
                            !libraryUploading.uploadTask.location_.path_.includes(
                              "ifc/" + WBSStore.WBS.data.development
                            )
                          ) {
                            return <div key={index}></div>; //delete cards in progress 100%
                          }
                          return (
                            <ul key={index} className={classes.ul}>
                              <div className={classes.controlWrapper}>
                                <div className={classes.controlUpload}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    <Tooltip
                                      title={libraryUploading.name}
                                      className={classes.tooltip}
                                    >
                                      <Typography
                                        variant="body1"
                                        gutterBottom
                                        className={classes.text}
                                        style={{
                                          maxWidth: "190px",
                                          whiteSpace: "nowrap",
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {libraryUploading.name}
                                      </Typography>
                                    </Tooltip>
                                    <Typography className={classes.processing}>
                                      Enviando{" "}
                                      {Math.floor(libraryUploading.loading)} %
                                    </Typography>
                                  </div>
                                  <CircularProgress
                                    className={classes.progressBack}
                                    variant="static"
                                    value={100}
                                  />
                                  <CircularProgress
                                    className={classes.progressCancel}
                                    variant="determinate"
                                    value={libraryUploading.loading}
                                  />
                                  <div
                                    onClick={() => this.cancelUpload(index)}
                                    className={classes.square}
                                  />
                                </div>
                              </div>
                            </ul>
                          );
                        }
                      )}
                    </li>
                  ) : (
                    false
                  )
                ) : (
                  false
                )}
                <li key={`section`} className={classes.list}>
                  {libraries.map(
                    (lib, index) =>
                      lib.data.status !== "deleted" && (
                        <ul className={classes.ul} key={index}>
                          <ListItem
                            button
                            divider
                            className={
                              this.state.selectedIndex === index
                                ? classes.controlWrapperSelected
                                : classes.controlWrapper
                            }
                            onClick={(event) =>
                              this.handleListItemClick(event, index, lib)
                            }
                            style={{ width: "100%" }}
                          >
                            <div className={classes.controls}>
                              <div
                                className={
                                  lib.data.status == "processing"
                                    ? classes.processingTitle
                                    : classes.titleDefault
                                }
                              >
                                <Tooltip
                                  title={(
                                    lib.data.realFileName || lib.data.name
                                  ).replace(
                                    DevelopmentStore.developmentSelected.id,
                                    ""
                                  )}
                                  className={classes.tooltip}
                                >
                                  <Typography
                                    variant="body1"
                                    gutterBottom
                                    className={classes.text}
                                    style={{
                                      maxWidth: "190px",
                                      whiteSpace: "nowrap",
                                      paddingBottom: 0,
                                    }}
                                  >
                                    {lib.data.realFileName
                                      ? lib.data.realFileName.replace(
                                          DevelopmentStore.developmentSelected
                                            .id,
                                          ""
                                        )
                                      : lib.data.name.replace(
                                          DevelopmentStore.developmentSelected
                                            .id,
                                          ""
                                        )}
                                  </Typography>
                                </Tooltip>
                                {lib.data.isImportProcessing && (
                                  <LabelProcessing
                                    className={classes.processing}
                                    progress={lib.data.importProgress}
                                    statusXkt={lib.data.statusXkt}
                                    status={lib.data.status}
                                  />
                                )}
                              </div>
                              <div
                                id="statusicon"
                                className={
                                  checkedRender.findIndex(function (value) {
                                    return value == `sw_${lib.id}`;
                                  }) >= 0
                                    ? classes.divVisibility
                                    : classes.divVisibilityOn
                                }
                              >
                                {lib.data.status == "processed" &&
                                lib.data.statusXkt == "processed" ? (
                                  <IconButton
                                    className={classes.iconNew}
                                    style={{ margin: 0 }}
                                    onClick={this.handleVisibilityChange(
                                      `sw_${lib.id}`,
                                      lib,
                                      index
                                    ).bind(this)}
                                  >
                                    {checkedRender.findIndex(function (value) {
                                      return value == `sw_${lib.id}`;
                                    }) >= 0 ? (
                                      <VisibilityIcon
                                        style={{
                                          fontSize: "18px",
                                          color: "rgba(255, 255, 255, 0.37)",
                                        }}
                                      />
                                    ) : (
                                      <VisibilityIconOff
                                        style={{
                                          fontSize: "18px",
                                          color: "#FFFFFF",
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                ) : lib.data.status == "error" ||
                                  lib.data.statusXkt == "error" ? (
                                  <PlayCircleOutline
                                    onClick={this.resetProccess(lib)}
                                    className={classes.errorButton}
                                  />
                                ) : lib.data.status == "pending" ? (
                                  <CircularProgress
                                    className={classes.progress}
                                    variant="indeterminate"
                                  />
                                ) : !lib.data.progress ? (
                                  <CircularProgress
                                    className={classes.progress}
                                    variant="indeterminate"
                                  />
                                ) : (
                                  <>
                                    <CircularProgress
                                      className={classes.progressBack}
                                      variant="static"
                                      value={100}
                                    />
                                    <CircularProgress
                                      className={classes.progressCancel}
                                      variant="determinate"
                                      value={parseInt(lib.data.progress)}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </ListItem>
                        </ul>
                      )
                  )}
                </li>
              </List>
            ) : (
              <div className={classes.table} style={{ margin: "0 auto" }}>
                <div className={classes.tableCell} style={{ padding: 0 }}>
                  <Dropzone
                    onDrop={this.onHandleDropzone}
                    // accept={".ifc, .ifczip"}
                    accept={".ifc"}
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={classes.table}>
            <div className={classes.tableCell}>
              <CircularProgress
                size={48}
                className={classes.icon}
                variant="indeterminate"
              />
              <Typography className={classes.stageTitle} component="span">
                {i18n.library.loading.title}
              </Typography>
              <Typography className={classes.stageSubtitle} component="span">
                {i18n.library.loading.subtitle1}
              </Typography>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(LibraryGrid));



// WEBPACK FOOTER //
// ./src/modules/library/components/pages/LibraryGrid.tsx